/**
 * Fourchette de prix — curseur double (collection + recherche)
 * Synchronise les range avec les champs Shopify (price-range).
 * Ne soumet le filtre qu'au relâchement (change) pour éviter le reset AJAX pendant le drag.
 */
(function () {
  function parseAmount(value) {
    const num = Number(String(value).replace(/,/g, ''));
    return Number.isFinite(num) ? num : 0;
  }

  function formatPrice(amount, currencySymbol) {
    const value = parseAmount(amount);
    const formatted = value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${formatted} ${currencySymbol}`;
  }

  function updateTrackFill(wrap, minRange, maxRange) {
    const fill = wrap.querySelector('.massin-facets-price__track--fill');
    if (!fill) return;

    const min = parseAmount(minRange.min);
    const max = parseAmount(maxRange.max);
    if (max <= min) return;

    const minVal = parseAmount(minRange.value);
    const maxVal = parseAmount(maxRange.value);
    const leftPct = ((minVal - min) / (max - min)) * 100;
    const widthPct = ((maxVal - minVal) / (max - min)) * 100;

    fill.style.left = `calc(0.675rem + (100% - 1.35rem) * ${leftPct / 100})`;
    fill.style.width = `calc((100% - 1.35rem) * ${widthPct / 100})`;
  }

  function initPriceSliders() {
    document.querySelectorAll('.massin-facets-price:not([data-massin-price-init])').forEach((wrap) => {
      const container = wrap.closest('.facets__display-vertical, .facets__display, .mobile-facets__submenu');
      const priceRange = container?.querySelector('price-range');
      if (!priceRange) return;

      const numberInputs = priceRange.querySelectorAll('input[type="number"]');
      if (numberInputs.length < 2) return;

      const minInput = numberInputs[0];
      const maxInput = numberInputs[1];
      const minRange = wrap.querySelector('.massin-facets-price__range--min');
      const maxRange = wrap.querySelector('.massin-facets-price__range--max');
      const minDisplay = wrap.querySelector('.massin-facets-price__value--min');
      const maxDisplay = wrap.querySelector('.massin-facets-price__value--max');

      if (!minRange || !maxRange) return;

      const currencySymbol = wrap.dataset.currencySymbol || 'Ar';
      const rangeMax = parseAmount(wrap.dataset.rangeMax || maxRange.max || maxInput.max);
      const minBound = parseAmount(minInput.min || 0);

      const syncDisplays = () => {
        if (minDisplay) {
          minDisplay.textContent = formatPrice(minRange.value, currencySymbol);
        }
        if (maxDisplay) {
          maxDisplay.textContent = formatPrice(maxRange.value, currencySymbol);
        }
      };

      const clampRanges = () => {
        let minVal = parseAmount(minRange.value);
        let maxVal = parseAmount(maxRange.value);

        if (minVal > maxVal) {
          if (document.activeElement === minRange) {
            maxVal = minVal;
            maxRange.value = String(maxVal);
          } else {
            minVal = maxVal;
            minRange.value = String(minVal);
          }
        }
      };

      const syncFromInputs = () => {
        const maxBound = parseAmount(maxRange.max) || rangeMax;
        let minVal = minInput.value !== '' ? parseAmount(minInput.value) : minBound;
        let maxVal = maxInput.value !== '' ? parseAmount(maxInput.value) : maxBound;

        minVal = Math.max(minBound, Math.min(minVal, maxBound));
        maxVal = Math.max(minBound, Math.min(maxVal, maxBound));
        if (minVal > maxVal) {
          maxVal = minVal;
        }

        minRange.value = String(minVal);
        maxRange.value = String(maxVal);
      };

      const syncToInputsSilent = () => {
        clampRanges();

        const minVal = parseAmount(minRange.value);
        const maxVal = parseAmount(maxRange.value);

        minInput.value = minVal > minBound ? String(minVal) : '';
        maxInput.value = maxVal >= rangeMax ? '' : String(maxVal);

        if (typeof priceRange.setMinAndMaxValues === 'function') {
          priceRange.setMinAndMaxValues();
        }
      };

      const submitFilter = () => {
        if (wrap.dataset.massinPriceSubmitting === 'true') return;

        syncToInputsSilent();
        wrap.dataset.massinPriceSubmitting = 'true';

        minInput.dispatchEvent(new Event('input', { bubbles: true }));
        maxInput.dispatchEvent(new Event('input', { bubbles: true }));

        window.setTimeout(() => {
          delete wrap.dataset.massinPriceSubmitting;
        }, 800);
      };

      const onRangeInput = () => {
        clampRanges();
        syncDisplays();
        updateTrackFill(wrap, minRange, maxRange);
        syncToInputsSilent();
      };

      syncFromInputs();
      syncDisplays();
      updateTrackFill(wrap, minRange, maxRange);

      minRange.addEventListener('input', onRangeInput);
      maxRange.addEventListener('input', onRangeInput);
      minRange.addEventListener('change', submitFilter);
      maxRange.addEventListener('change', submitFilter);

      wrap.dataset.massinPriceInit = 'true';
    });
  }

  let initTimer;
  function scheduleInit() {
    window.clearTimeout(initTimer);
    initTimer = window.setTimeout(initPriceSliders, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  document.addEventListener('shopify:section:load', scheduleInit);

  ['main-collection-filters', 'main-search-filters'].forEach((id) => {
    const aside = document.getElementById(id);
    if (!aside) return;

    const observer = new MutationObserver((mutations) => {
      const hasNewSlider = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            (node.classList?.contains('massin-facets-price') || node.querySelector?.('.massin-facets-price'))
        )
      );

      if (hasNewSlider) {
        scheduleInit();
      }
    });

    observer.observe(aside, { childList: true, subtree: true });
  });
})();
